'use client';

import { useTranslations } from 'next-intl';
import { useRealtimeStatusStore } from '../stores/realtimeStatusStore';

/**
 * SSE 실시간 연결이 불안정할 때(재연결 연속 실패) 상단에 고정 배너를 띄우는 스톱갭 UI.
 * 연결이 복구되면 RealtimeEventsProvider가 상태를 "connected"로 되돌려 자동으로 사라진다.
 */
export const RealtimeStatusBanner = () => {
  const t = useTranslations('components.realtimeStatusBanner');
  const status = useRealtimeStatusStore((state) => state.status);

  if (status !== 'unstable') {
    return null;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-[80] flex items-center justify-center gap-2 border-t border-warning/30 bg-warning/15 px-4 py-2 text-center text-xs font-medium text-base-content backdrop-blur-xs"
    >
      <span className="inline-block h-2 w-2 shrink-0 animate-pulse rounded-full bg-warning" aria-hidden="true" />
      <span>{t('unstableMessage')}</span>
    </div>
  );
};
